<template>
  <div class="container page" style="background: #f4f4f4;">
    <van-nav-bar :title="$t('wallet.wallet_label')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#333" @click="back()" />
      </template>
      <template #right>
        <span v-if="is_bind" class="nav-right" style="color: #333;" @click="toBindCard()">{{$t('wallet.edit')}}</span>
      </template>
    </van-nav-bar>

    <div class="page-body">
      <!-- 已绑定：只展示地址 -->
      <div class="addr-card" v-if="is_bind">
        <div class="addr mono">{{ bankInfo.bankid }}</div>
        <div class="addr-actions">
          <span class="act" @click="copyAddress">{{$t('wallet.copy_address')}}</span>
          <span class="act" @click="toBindCard()">{{$t('wallet.edit')}}</span>
        </div>
      </div>
      <!-- 未绑定：添加地址 -->
      <div class="addr-card empty" v-else @click="toBindCard()">
        <van-icon name="plus" />
        <span>{{$t('wallet.add_wallet')}}</span>
      </div>

      <div class="tips">{{ $t("wallet.bind_warn") }}</div>
    </div>
  </div>
</template>

<script>
import { copyText } from '@/common/wallet'

export default {
  data() {
    return {
      is_bind: false,
      bankInfo: {},
      userInfo: {}
    }
  },
  methods: {
    back() {
      return window.history.back()
    },
    copyAddress() {
      copyText(this.bankInfo.bankid).then(ok => {
        this.$toast(ok ? this.$t('wallet.copied') : this.$t('wallet.copy_failed'))
      })
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.is_bind = true
            this.bankInfo = res.data.info || {}
          } else {
            this.is_bind = false
          }
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    },
    toBindCard() {
      // 绑定/修改都需要姓名，没设置先去设置姓名
      if (!this.userInfo.name) {
        this.$router.push("Setname")
        this.$toast(this.$t("setting.set_name_bank"))
        return true
      }
      this.$router.push({ path: '/BindWallet' })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserInfo()
      this.getUserBankInfo()
    }
  }
}
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.page-body{
  padding: 0 30px 40px;
}
/* 地址卡片 */
.addr-card{
  margin-top: 30px;
  padding: 30px;
  border-radius: 16px;
  background: #fff;
  border: 2px solid #eee;
  .addr{
    font-size: 30px;
    line-height: 46px;
    color: #333;
    word-break: break-all;
  }
  .mono{
    font-family: Consolas, Monaco, monospace;
  }
  .addr-actions{
    display: flex;
    justify-content: flex-end;
    margin-top: 28px;
    .act{
      margin-left: 36px;
      font-size: 28px;
      font-weight: bold;
      color: rgb(172, 98, 204);
    }
  }
  /* 空态 */
  &.empty{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    color: #999;
    font-size: 28px;
    border-style: dashed;
    .van-icon{
      font-size: 48px;
      margin-bottom: 16px;
    }
  }
}
.tips{
  margin-top: 24px;
  font-size: 25px;
  line-height: 36px;
  color: #979799;
}
</style>
